import axios from 'axios';
import { API } from '../api';
import axiosInstance from '../axiosConfig';
import { useAuthStore } from '../../zustand-store/auth.store';
import { createBrowserRouter } from 'react-router-dom';

export const loginApiDev = async ({ email, password }) => {
  const response = await axiosInstance.post(
    API.AUTH_DEV.LOGIN,
    { email, password },
    { withCredentials: true }
  );
  if (!response.data?.data?.accessToken) {
    return response;
  }
  const refreshToken = response.data.data.refreshToken;
  const accessToken = response.data.data.accessToken;
  const detailsProvided = response.data.data.detailsProvided;
  localStorage.setItem('token', refreshToken);
  useAuthStore.getState().setAccessToken(accessToken);
  useAuthStore.getState().setDetailsProvided(detailsProvided);
  return response.data;
};

export const loginApiProd = async ({ email, password }) => {
  const response = await axiosInstance.post(
    API.AUTH.LOGIN,
    { email, password },
    { withCredentials: true }
  );
  if (!response.data?.data?.accessToken) {
    return response;
  }
  const accessToken = response.data.data.accessToken;
  const detailsProvided = response.data.data.detailsProvided;
  if (accessToken) {
    useAuthStore.getState().setAccessToken(accessToken);
    useAuthStore.getState().setDetailsProvided(detailsProvided);
  }
  return response.data;
};

export const refreshTokenDev = async () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL_BACKEND;
  const token = localStorage.getItem('token');

  // ✅ If no token, return null (don't call API)
  if (!token || token == 'undefined') {
    return null;
  }

  try {
    const response = await axios.post(BASE_URL + API.AUTH_DEV.REFRESH + token, {
      withCredentials: true
    });

    const accessToken = response.data?.data?.accessToken;
    const refreshToken = response.data?.data?.refreshToken;

    if (refreshToken) {
      localStorage.setItem('token', refreshToken);
    }

    if (accessToken) {
      await useAuthStore.getState().setAccessToken(accessToken);
    }

    return accessToken || null;
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return null;
  }
};

export const refreshTokenProd = async () => {
  const BASE_URL = import.meta.env.VITE_BASE_URL_BACKEND;
  const response = await axios.post(BASE_URL + API.AUTH.REFRESH, {}, { withCredentials: true });
  const accessToken = response?.data?.data?.accessToken || '';
  // tokenService.clearToken();
  // tokenService.setToken(accessToken);
  if (accessToken) {
    await useAuthStore.getState().setAccessToken(accessToken);
    return accessToken;
  } else {
    return null;
  }
};

export const logoutDev = async () => {
  localStorage.removeItem('token');
  localStorage.removeItem('');
  //navigate to login page
};

export const logoutProd = async () => {
  //navigate the user to login page
  const BASE_URL = import.meta.env.VITE_BASE_URL_BACKEND;
  await axios.get(BASE_URL + API.AUTH.LOGOUT, { withCredentials: true });
  const router = createBrowserRouter(['/login']);
  router.navigate('/login');
};

export const verifyEmail = async (token) => {
  const response = await axiosInstance.get(API.AUTH.VERIFY + token);
  return response;
};
